/**
 * 无需登录即可访问的路由名称
 * @type {string[]}
 */
export const PUBLIC_ROUTE_NAMES = ['ResourceSharePublic', 'PublicLibrary', 'ShareMissingToken']

/**
 * 从 hash 中解析路径（hash 路由兜底）
 * @returns {string}
 */
function getHashRoutePath() {
  if (typeof window === 'undefined') return ''
  const hash = window.location.hash || ''
  if (!hash.startsWith('#/')) return ''
  const path = hash.slice(1)
  const q = path.indexOf('?')
  return q >= 0 ? path.slice(0, q) : path
}

/**
 * 是否为公开路由（分享页、资料库等）
 * @param {import('vue-router').RouteLocationNormalized} to
 * @returns {boolean}
 */
export function isPublicRoute(to) {
  if (to.meta && to.meta.public) {
    return true
  }
  if (to.name && PUBLIC_ROUTE_NAMES.includes(String(to.name))) {
    return true
  }
  if (to.path && (to.path.startsWith('/share/') || to.path === '/library' || to.path === '/share')) {
    return true
  }
  if (to.matched && to.matched.some((record) => record.meta && record.meta.public)) {
    return true
  }
  const hashPath = getHashRoutePath()
  if (hashPath.startsWith('/share/') || hashPath === '/library' || hashPath === '/share') {
    return true
  }
  return false
}

/**
 * 是否已登录（与 login.vue 写入的 sessionStorage 一致）
 * @returns {boolean}
 */
export function isAuthenticated() {
  return sessionStorage.getItem('s') === 'true'
}
